
import i18n from '@/i18n';export type ResourcePackgeConfig = {
  // 额度
  quota: number;
  // 套餐价格
  price: number;
  // mau
  mau: number;
  // 折扣
  discount?: number;
  discountInFirstTime?: number;
};

export type PackageListItem = {
  quota: number,
  price: number,
  discount: number,
  discountPrice: number,
  count: number,
};

export type Voucher = {
  // 代金券金额
  amount: number;
  // 满多少可用
  usedPrice: number;
};

export enum ResourceType {
  Annual = 'annual',
  PayperUse = 'payperuse',
  DeviceUnLimited = 'device_unlimited',
  MiniPayperuse = 'mini_payperuse',
}

export const RESOURCE_TYPE_MAP: Record<ResourceType, string> = {
  [ResourceType.Annual]: i18n.t('MAU包年套餐'),
  [ResourceType.PayperUse]: i18n.t('事件量套餐'),
  [ResourceType.DeviceUnLimited]: i18n.t('月活套餐'),
  [ResourceType.MiniPayperuse]: i18n.t('小程序事件量套餐'),
};
